import { Position } from './types'

interface CalculateDropdownPositionParams {
  triggerRect: DOMRect
  contentRect: DOMRect
  offsetY: number
  offsetX: number
  position: Position
}

const SECURITY_MARGIN = 8

export function calculateDropdownPosition({
  triggerRect,
  contentRect,
  offsetY,
  offsetX,
  position,
}: CalculateDropdownPositionParams): { top: number; left: number } {
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  let top = 0
  let left = 0

  const positions: Record<Position, () => void> = {
    top: () => {
      top = triggerRect.top - contentRect.height - offsetY
      left = triggerRect.left + offsetX
    },
    bottom: () => {
      top = triggerRect.bottom + offsetY
      left = triggerRect.left + offsetX
    },
    left: () => {
      top = triggerRect.top
      left = triggerRect.left - contentRect.width - offsetX
    },
    right: () => {
      top = triggerRect.top
      left = triggerRect.right + offsetX
    },
  }

  positions[position]()

  if (left + contentRect.width > viewportWidth)
    left = viewportWidth - contentRect.width - SECURITY_MARGIN

  if (left < 0) left = SECURITY_MARGIN

  if (top + contentRect.height > viewportHeight)
    top = viewportHeight - contentRect.height - SECURITY_MARGIN

  if (top < 0) top = SECURITY_MARGIN

  return { top, left }
}
